/*

 */

import {Form} from '../modules/Form';
import {event} from "./event";

var poll = function(el){
    var elForm = el.querySelector('[data-poll-form]'),
        elTotal = el.querySelector('[data-poll-total]'),
        oForm = new Form({
            wrapper:elForm,
            onsuccess:function(data){
                showResults(data);
            },
            onerror:function(data){
                alert(data.message);
            }
        }),
        answerAll = el.querySelectorAll('[data-poll-answer]'),
        answersObj = {},
        resultBtn = el.querySelector('[data-poll-resultBtn]'),
        checkAuth = function (e){
            if(APP.vars.isMobile){
                if (APP.auth.tryAuth()) return true;
                else return false;
            } else {
                if(!regAuthObj.isAuth){
                    e.preventDefault();
                    regAuthObj.authForm.showPopup();
                    return false;
                }
                return true;
            }
        },
        Answer = class{
            constructor(el){
                this.createElements(el);
                this.addEvents();
            }

            addRes(data){
                this.elField.checked = data.uservoted;
                this.elField.setAttribute('disabled', true); /* на всякий случай. И так дисаблится стилем pointer-events */
                this.elProgress.style.width = data.percentage + '%';
            }

            createElements(el){
                this.el = el;
                this.elProgress = this.el.querySelector('[data-poll-progress]');
                this.elField = this.el.querySelector('[data-poll-field]');
            }

            addEvents(){
                this.el.addEventListener('click', (e) => {checkAuth(e)});
            }
        },
        confirmResults = function(){
            if(!regAuthObj.isAuth){
                regAuthObj.authForm.showPopup();
            }
            else if(confirm('После просмотра результатов голосование невозможно')){
                elForm.reset();
                elForm.submit();
                el.classList.add('js-loading');
            }
        },
        showResults = function(data){
            el.classList.remove('js-loading');
            el.classList.add('js-result');

            for(var key in answersObj){
                answersObj[key].addRes(data.result[key]);
            }

            elTotal.innerHTML = data.result.total + ' ' + APP.helpers.decline(data.result.total, ['голос', 'голоса', 'голосов']);
        },
        submitForm = function(e){
            e.preventDefault();

            if(!checkAuth(e)) return;

            if (!e.target.checkValidity()) {
                if(APP.vars.isMobile){
                    alert('Пожалуйста, ответьте на вопрос');
                } else{
                    uPopup({
                        content:'Пожалуйста, ответьте на вопрос'
                    });
                }
            }
            else {
                elForm.submit();
                el.classList.add('js-loading');
            }
        };

    //
    elForm.addEventListener('submit', submitForm);

    for(var i=0,j=answerAll.length; i<j; i++){
        var key = answerAll[i].getAttribute('data-poll-answer');
        answersObj[key] = new Answer(answerAll[i]);
    }

    resultBtn.addEventListener('click', confirmResults);
};

export {poll};





